//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html, PropertyValues } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/jha-container/jha-container";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@jack-henry/jh-icons/icons-wc/icon-building-columns";
import "@banno/jha-wc/src/icons/jha-icon-edit";
import "@banno/jha-wc/src/icons/jha-icon-plus";
import "@banno/jha-wc/src/icons/jha-icon-cards";
import "@banno/jha-wc/src/icons/jha-icon-search";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import { fixedEncodeURIComponent, getRequest, putRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { StatusConstants } from "../../utils/apiStatusConstants";
import { GlobalConstants, GlobalVariables } from "../../utils/constants";
import {
    ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT,
    applyAdvancedTableHeaderLayout,
    stringComparison,
    decryptValue,
    showToastMessage,
    renderAdvancedTableEllipsisCell,
    buildAdvancedTableEllipsisColumnShadowCss,
    stripAdvancedTableRedundantTitles,
} from "../../utils/app-utils";
import {
    dateTimeColumnLabel,
    EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT,
    EFM_TIMEZONE_GRID_TABLE_STYLE,
    formatEpochSecondsForDisplay,
    normalizeEpochSeconds,
    renderGridWithTimezoneBanner,
} from "../../utils/datetime-display";
import { AppRouters } from "../../utils/app-router";
import { EditBusinessUnitType } from "../../types/BusinessUnits/EditBusinessUnitType";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import Cookies from "js-cookie";
import "../../Components/Loader";
import { jhaDropdownMenuPanelStylesText } from "../../styles/jha-dropdown-menu-panel";
import { FeatureFlags } from "../../utils/launchdarkly-config";
import { launchDarkly } from "../../utils/launchdarkly-service";
import { isInitialInstitutionFeatureEnabled } from "../../utils/initial-institution-feature-gate";

@customElement("business-units-main-view")
export class BusinessUnitsMainView extends routingMixin(LitElement) {
    static get is() {
        return "business-units-main-view";
    }
    constructor() {
        super();
    }

    @property({ type: String })
    loggedUserBu = Cookies.get("businessUnit");

    static readonly BUSINESS_UNIT_ELLIPSIS_TITLE_COLUMN_IDS = new Set([
        "businessUnitName",
        "description",
    ]);

    get businessUnitColumns() {
        const baseColumns = [
            {
                id: "businessUnitName",
                label: "BUSINESS UNIT NAME",
                sortBy: true,
                valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
            },
            {
                id: "description",
                label: "DESCRIPTION",
                valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
            },
            {
                id: "createDateTime",
                label: dateTimeColumnLabel("CREATED ON"),
                sortBy: true,
                dataType: "number",
                /** Suppress native button title (raw epoch seconds); display via valueRenderer. */
                valueFormatter: () => "",
                valueRenderer: (val: unknown) =>
                    html`<span style="white-space: nowrap;">${formatEpochSecondsForDisplay(normalizeEpochSeconds(val))}</span>`,
            },
            {
                id: "createdBy",
                label: "CREATED BY",
                sortBy: true,
            },
            {
                id: "updateDateTime",
                label: dateTimeColumnLabel("UPDATED ON"),
                sortBy: true,
                dataType: "number",
                valueFormatter: () => "",
                valueRenderer: (val: unknown) =>
                    html`<span style="white-space: nowrap;">${formatEpochSecondsForDisplay(normalizeEpochSeconds(val))}</span>`,
            },
            {
                id: "updatedBy",
                label: "UPDATED BY",
                sortBy: true,
            },
            {
                id: "status",
                label: "BUSINESS UNIT STATUS",
                sortBy: true,
                valueRenderer: (val: string, businessUnit: any) => {
                    return html`
        <jha-tooltip data-auto-id="statusTooltip${businessUnit.businessUnitId}" right
            text=${businessUnit.status?.toLowerCase() === "active" ? "Click to Disable Business Unit"
                            : "Click to Enable Business Unit"}>
            <jha-form-switch data-auto-id=${"statusSwitch" + businessUnit.businessUnitId} ?disabled=${this.isReadOnlyUser ||
                        businessUnit?.buNameLower === this.loggedUserBu?.toLowerCase()} ?checked=${stringComparison(val, "active")}
                @change=${() => this.updateBusinessUnitStatus(businessUnit)}>
            </jha-form-switch>
        </jha-tooltip>
        `;
                },
            },
        ];

        const actionColumn = {
            id: "actionId",
            label: "",
            alignRight: true,
            valueFormatter: () => "",
            valueRenderer: (_val: unknown, row: any) =>
                html`
        ${this.showViewInstitutionsAction
                        ? html`
        <jha-tooltip left text="Manage Institutions">
            <jh-icon-building-columns class="icon" data-auto-id=${"viewInstitutions_" + row.businessUnitId} style="cursor: pointer; margin-right: 10px; --icon-size: 24px; --jh-icon-color-fill: #ffffff;" @click=${() =>
                                this.onViewInstitutions(row.businessUnitId)}>
            </jh-icon-building-columns>
        </jha-tooltip>`
                        : html``}
        ${!this.isReadOnlyUser
                        ? html`
        <jha-tooltip left text="Edit Business Unit">
            <jha-icon-edit class="icon" style="cursor: pointer;" @click=${() =>
                                this.onEditBusinessUnit(row.businessUnitId)}>
            </jha-icon-edit>
        </jha-tooltip>`
                        : html``}
        `,
        };

        return [...baseColumns, actionColumn];
    }

    @property({ type: Boolean }) isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole") || "")) ? true : false;
    @property({ type: Boolean }) isEnterpriseAdmin = /enterpriseadmin/i.test(decryptValue(Cookies.get("userType") || ""));

    get showViewInstitutionsAction(): boolean {
        return isInitialInstitutionFeatureEnabled();
    }

    private handleInitialInstitutionFlagChange = (): void => {
        this.requestUpdate();
    };

    private refreshFlagValues = (): void => {
        this.requestUpdate();
    };
    @property({ type: Boolean }) loadingMore = false;
    @property({ type: Boolean }) apiLoading = false;
    @property({ type: Number }) allRecords = 100000; // Set a high number to fetch all records in one go
    @property({ type: String }) pageTitle = "Business Units";
    @property({ type: String }) sortColumnId = "";
    @property({ type: Number }) pageLimit = 20;
    @property({ type: String }) pageKey = "";
    @property({ type: String }) nextPageKey = "";
    @property({ type: Object })
    advancedTableConfig = {
        apiControlled: false,
        apiTotal: 100,
        sort: {
            columnId: "updateDateTime",
            descending: true,
        },
    };

    @property({ type: Object })
    businessUnitsData: {
        messageStatus: string;
        results: any[];
        pageKey: string;
        totalCount: number;
    } = {
            messageStatus: "",
            results: [],
            pageKey: "",
            totalCount: 0,
        };

    @property({ type: Boolean }) searchBusinessUnit = false;
    @property() filterSearchBusinessUnit = "";

    static readonly styles = css`
    .icon {
      cursor: pointer;
      color: var(--jha-color-primary);
      width: 20px;
      height: 20px;
    }

    jh-icon-building-columns.icon {
      --icon-size: 24px;
      --jh-icon-color-fill: #ffffff;
    }

    #tableCon {
      display: flex;
      flex-direction: column;
      padding: 24px;
      flex: 1;
      overflow: hidden;
    }

    #businessUnitsMain {
      display: flex;
      flex-direction: column;
      padding: 24px;
      flex: 1;
      overflow: hidden;
    }

    #formCon {
      display: flex;
      flex-direction: row;
      gap: 15px;
      align-items: center;
      justify-content: space-between;
    }
    .inputContainer {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    #noData {
      display: flex;
      justify-content: center;
    }

    div.table-wrapper {
      overflow-x: auto;
    }

    #table-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
    }

    jha-table {
      width: 100%;
    }

    jh-input {
      max-width: 350px;
    }

    jha-form-select {
      min-width: 350px;
    }

    jha-form-row {
      align-items: baseline;
      justify-content: flex-end;
      flex: 1;
    }

    jha-table-header {
      width: 20vw;
    }

    jha-card {
      margin-top: 10px;
      flex: 1;
      overflow: hidden;
      margin-left: 0px;
      margin-right: 0px;
      padding: 5px;
    }
  `;

    clearButtonLoading() {
        const addNewBusinessUnitButton = this.shadowRoot?.querySelector(
            "jha-button[data-auto-id='addNewBusinessUnitButton']"
        ) as HTMLButtonElement;
        addNewBusinessUnitButton.removeAttribute("isLoading");
    }

    onAddBusinessUnit() {
        try {
            AppRouters.go("/business-units/add-business-unit");
        } finally {
            this.clearButtonLoading();
        }
    }

    onViewInstitutions(businessUnitId: string) {
        if (!businessUnitId) return;
        AppRouters.go("/business-units/" + fixedEncodeURIComponent(businessUnitId) + "/institutions");
    }

    onEditBusinessUnit(businessUnitId: string) {
        AppRouters.go("/business-units/edit-business-unit/" + fixedEncodeURIComponent(businessUnitId));
    }

    /** Numeric epoch seconds for jha-advanced-table `dataType: "number"` cells and comparisons. */
    private static toEpochSecondsForSort(raw: unknown): unknown {
        if (raw == null || raw === "") {
            return raw;
        }
        if (typeof raw === "number" && Number.isFinite(raw)) {
            return raw < 10000000000 ? raw : Math.floor(raw / 1000);
        }
        const s = String(raw).trim();
        if (/^\d{10,13}$/.test(s)) {
            const n = parseInt(s, 10);
            return n < 10000000000 ? n : Math.floor(n / 1000);
        }
        const ms = Date.parse(s);
        if (!Number.isNaN(ms)) {
            return Math.floor(ms / 1000);
        }
        return raw;
    }

    /** Epoch seconds as a number for default ordering (newest first). */
    private static epochSecondsForCompare(raw: unknown): number {
        const v = BusinessUnitsMainView.toEpochSecondsForSort(raw);
        if (typeof v === "number" && Number.isFinite(v)) {
            return v;
        }
        if (v == null || v === "") {
            return 0;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    }

    /** Newest `updateDateTime` first so the list matches default grid sort even if API order varies. */
    private static sortResultsByUpdateDateTimeDesc(results: any[]): any[] {
        if (!results?.length) {
            return results;
        }
        return [...results].sort((a, b) => {
            const eb = BusinessUnitsMainView.epochSecondsForCompare(b?.updateDateTime ?? b?.UpdateDateTime);
            const ea = BusinessUnitsMainView.epochSecondsForCompare(a?.updateDateTime ?? a?.UpdateDateTime);
            return eb - ea;
        });
    }

    get businessUnitList() {
        //I have seen status be null in the API response, so I am setting it to inactive if it is null.
        return this.businessUnitsData.results.map((item: any) => {
            const createRaw = item.createDateTime ?? item.CreateDateTime;
            const updateRaw = item.updateDateTime ?? item.UpdateDateTime;
            return {
                ...item,
                createDateTime: BusinessUnitsMainView.toEpochSecondsForSort(createRaw),
                updateDateTime: BusinessUnitsMainView.toEpochSecondsForSort(updateRaw),
                status: item.status === null ? "inactive" : item.status,
                actionId: item.businessUnitId ?? "",
            };
        });
    }

    onSearchBusinessUnit() {
        this.filterSearchBusinessUnit = this.filterSearchBusinessUnit.trimStart().trimEnd();
        if (this.filterSearchBusinessUnit.length > 0) {
            this.getAllBusinessUnitsList(this.filterSearchBusinessUnit);
        } else {
            this.getAllBusinessUnitsList("");
        }
    }

    onSearchBusinessUnitChange(e: { target: { value: string } }) {
        this.filterSearchBusinessUnit = e.target.value;
    }

    async onSearchBusinessUnitClear() {
        this.filterSearchBusinessUnit = "";
        await this.getAllBusinessUnitsList("");
    }

    async updateBusinessUnitStatus(businessUnit: any) {
        if (this.isReadOnlyUser) {
            showToastMessage("You do not have permission to update the Business Unit status.", "danger");
            return;
        }

        const isCurrentlyActive = businessUnit.status === "active";
        if (isCurrentlyActive) {
            const confirmed = await this.confirmDisableBusinessUnit();
            if (!confirmed) {
                this.handleStatusUpdateCancelled(businessUnit);
                return;
            }
        }

        const newStatus = isCurrentlyActive ? "inactive" : "active";
        this.apiLoading = true;

        try {
            const latestData = await getRequest(Apis.GET_BUSINESSUNIT + `/${businessUnit.businessUnitId}`);
            // jha-fetch returns undefined on network error (and already toasts "Something went wrong...").
            // Do NOT toast again here — just revert the tooltip and bail so we don't stack toasts.
            if (!latestData) {
                this.updateStatusTooltip(businessUnit.businessUnitId, businessUnit.status);
                return;
            }

            const updatePayload = this.buildUpdatePayload(businessUnit, newStatus, latestData.eTag);

            const updateResponse = await putRequest<EditBusinessUnitType>(
                Apis.UPDATE_BUSINESSUNIT + `/${businessUnit.businessUnitId}`,
                latestData.eTag,
                updatePayload
            );

            if (!updateResponse) {
                // Same contract as above — jha-fetch already toasted.
                this.updateStatusTooltip(businessUnit.businessUnitId, businessUnit.status);
                return;
            }

            if (updateResponse.messageStatus === null) {
                this.handleStatusUpdateSuccess(businessUnit, newStatus, updateResponse.eTag);
                const updatedData = await getRequest(Apis.GET_BUSINESSUNIT + `/${businessUnit.businessUnitId}`);
                if (updatedData) {
                    // Update the UI with the latest data from the server after status change
                    const merged = this.businessUnitsData.results.map((item: any) =>
                        item.businessUnitId === businessUnit.businessUnitId ? { ...item, ...updatedData } : item
                    );
                    this.businessUnitsData = {
                        ...this.businessUnitsData,
                        results: BusinessUnitsMainView.sortResultsByUpdateDateTimeDesc(merged),
                    };
                }
            } else if (updateResponse.details?.length > 0) {
                this.handleStatusUpdateError(businessUnit, getErrorMessage(updateResponse.details));
            } else {
                this.handleStatusUpdateError(businessUnit, "Something went wrong, please try again.");
            }
        } catch {
            // Defensive only — jha-fetch swallows network errors and toasts itself, so we normally
            // never land here. No extra toast; just restore the tooltip and let `finally` clear the flag.
            this.updateStatusTooltip(businessUnit.businessUnitId, businessUnit.status);
        } finally {
            this.apiLoading = false;
        }
    }

    private handleStatusUpdateCancelled(businessUnit: any) {
        this.apiLoading = false;
        showToastMessage("Business Unit status update cancelled.", "success");
        this.updateStatusTooltip(businessUnit.businessUnitId, businessUnit.status);
        this.resetStatusSwitch(businessUnit);
    }

    private handleStatusUpdateSuccess(businessUnit: any, newStatus: string, eTag?: string) {
        showToastMessage(`${businessUnit.businessUnitName} status has been updated successfully.`, "success");
        this.updateStatusTooltip(businessUnit.businessUnitId, newStatus);
        this.businessUnitsData = {
            ...this.businessUnitsData,
            results: this.businessUnitsData.results.map((item: any) =>
                item.businessUnitId === businessUnit.businessUnitId ? { ...item, status: newStatus, eTag: eTag ?? item.eTag } : item
            ),
        };
    }

    private handleStatusUpdateError(businessUnit: any, message: string) {
        showToastMessage(message, "danger");
        this.updateStatusTooltip(businessUnit.businessUnitId, businessUnit.status);
    }

    private resetStatusSwitch(businessUnit: any) {
        const table = this.shadowRoot?.querySelector("jha-advanced-table");
        let statusSwitch: HTMLElement | null = null;
        if (table && (table as any).shadowRoot) {
            statusSwitch = (table as any).shadowRoot.querySelector(
                `jha-form-switch[data-auto-id='statusSwitch${businessUnit.businessUnitId}']`
            );
        }

        if (!statusSwitch) {
            statusSwitch =
                (this.shadowRoot?.querySelector(
                    `jha-form-switch[data-auto-id='statusSwitch${businessUnit.businessUnitId}']`
                ) as HTMLElement | null) || null;
        }

        if (statusSwitch) {
            try {
                (statusSwitch as any).checked = businessUnit.status === "active";
            } catch {
                // Ignore errors
            }
        }
    }

    private buildUpdatePayload(businessUnit: any, status: string, eTag: string) {
        return {
            businessUnitId: businessUnit.businessUnitId,
            businessUnitName: businessUnit.businessUnitName,
            description: businessUnit.description,
            status,
            updatedBy: businessUnit.updatedBy,
            eTag,
        };
    }

    private async confirmDisableBusinessUnit(): Promise<boolean> {
        const result = await openJhftDialog({
            variant: "danger",
            title: "Disable Business Unit",
            message:
                "Are you sure you want to disable this Business Unit?\n\n" +
                "All users and workflows associated with this Business Unit will also be disabled.",
            cancelLabel: "Cancel",
            confirmLabel: "Disable",
        });
        return result === "confirm";
    }

    private updateStatusTooltip(businessUnitId: string, status: string) {
        const table = this.shadowRoot?.querySelector("jha-advanced-table");
        let statusTooltip: HTMLElement | null = null;
        if (table && (table as any).shadowRoot) {
            statusTooltip = (table as any).shadowRoot.querySelector(`jha-tooltip[data-auto-id='statusTooltip${businessUnitId}']`);
            if (statusTooltip) {
                statusTooltip.setAttribute("text", status === "active" ? "Click to Disable Business Unit" : "Click to Enable Business Unit");
            }
        }
    }

    async getAllBusinessUnitsList(searchString: string) {
        this.apiLoading = true;
        this.filterSearchBusinessUnit = searchString;
        this.searchBusinessUnit = true;
        try {
            const getBusinessUnits = await getRequest<{ businessUnit: string }>(Apis.GET_ALL_BUSINESSUNITS + `?count=${this.allRecords}`);

            if (!getBusinessUnits) {
                return;
            }

            if (getBusinessUnits?.messageStatus === null) {
                const results = BusinessUnitsMainView.sortResultsByUpdateDateTimeDesc(getBusinessUnits.results || []);
                this.businessUnitsData = { ...getBusinessUnits, results };
                this.advancedTableConfig = {
                    ...this.advancedTableConfig,
                    apiTotal: getBusinessUnits?.totalCount,
                    sort: {
                        columnId: "updateDateTime",
                        descending: true,
                    },
                };
                this.nextPageKey = getBusinessUnits?.pageKey;
            } else if (getBusinessUnits?.status === StatusConstants.NOT_FOUND_BUSINESSUNITID_CODE) {
                this.businessUnitsData = {
                    messageStatus: "",
                    results: [],
                    pageKey: "",
                    totalCount: 0,
                };
            } else if (getBusinessUnits?.details?.length > 0) {
                showToastMessage(getErrorMessage(getBusinessUnits?.details), "danger");
            } else {
                showToastMessage("Something went wrong, please try again.", "danger");
            }
        } catch {
            showToastMessage("Something went wrong, please try again.", "danger");
        } finally {
            this.searchBusinessUnit = false;
            this.apiLoading = false;
        }
    }

    async connectedCallback() {
        super.connectedCallback();
        document.title = GlobalVariables.MAIN_TITLE?.concat(" >", this.pageTitle);
        this.refreshFlagValues();
        launchDarkly.whenReady().then(() => this.refreshFlagValues());
        launchDarkly.on(FeatureFlags.INITIAL_INSTITUTION, this.handleInitialInstitutionFlagChange);
    }

    disconnectedCallback() {
        launchDarkly.off(FeatureFlags.INITIAL_INSTITUTION, this.handleInitialInstitutionFlagChange);
        super.disconnectedCallback();
    }

    /**
     * When the main Business Units grid is shown (not add/edit subroutes), reload data and
     * reset sort to Updated On descending so the most recently updated row is first.
     * Navigating back from edit uses the same path without a child route — this runs then.
     */
    async routeEnter(currentNode: unknown, nextNodeIfExists: unknown, routeId: string, context: unknown) {
        await super.routeEnter(currentNode, nextNodeIfExists, routeId, context);
        if (!nextNodeIfExists) {
            this.advancedTableConfig = {
                ...this.advancedTableConfig,
                sort: {
                    columnId: "updateDateTime",
                    descending: true,
                },
            };
            const q = typeof this.filterSearchBusinessUnit === "string" ? this.filterSearchBusinessUnit.trim() : "";
            await this.getAllBusinessUnitsList(q);
        }
    }

    renderTable() {
        return html`
            <jha-advanced-table
                style=${EFM_TIMEZONE_GRID_TABLE_STYLE}
                .tableConfig=${this.advancedTableConfig}
                .columns=${this.businessUnitColumns}
                .data=${this.businessUnitList}
                .fullWidthColumns=${true}
                .pageLimit=${this.pageLimit}
                .allowPageChange=${true}
                .allowPageLimitChange=${true}
                .loading=${this.searchBusinessUnit}
                .noContentMessage=${"No Data to Display"}
                @table-update=${this.handleTableUpdate}
            ></jha-advanced-table>
        `;
    }

    updated(changed: PropertyValues) {
        super.updated?.(changed);
        const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
        if (table) {
            table.toggleAttribute(
                "data-api-loading",
                this.apiLoading || this.searchBusinessUnit || this.loadingMore,
            );
            table.toggleAttribute(
                "data-has-data",
                (this.businessUnitsData?.results?.length ?? 0) > 0,
            );
        }
        requestAnimationFrame(() => this.injectAdvancedTableStyles());
    }

    private handleTableUpdate() {
        requestAnimationFrame(() => this.injectAdvancedTableStyles());
    }

    private injectAdvancedTableStyles() {
        const table = this.renderRoot.querySelector("jha-advanced-table") as HTMLElement | null;
        const root = table?.shadowRoot;
        if (!root) return;
        const css = `
            ${ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT}
            ${EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT}
            ${jhaDropdownMenuPanelStylesText}
            .loading jh-progress { visibility: hidden; }
            :host([data-api-loading]) .no-content,
            :host([data-has-data]) .no-content { visibility: hidden; }
            .no-content p {
                font-size: 20px;
                font-weight: 600;
                margin: 0;
            }
            ${buildAdvancedTableEllipsisColumnShadowCss([
            "businessUnitName",
            "description",
        ])}
        `;
        let style = root.querySelector("style[data-acme-1180]") as HTMLStyleElement | null;
        if (!style) {
            style = document.createElement("style");
            style.setAttribute("data-acme-1180", "");
            root.appendChild(style);
        }
        style.textContent = css;
        applyAdvancedTableHeaderLayout(root);
        stripAdvancedTableRedundantTitles(
            root,
            BusinessUnitsMainView.BUSINESS_UNIT_ELLIPSIS_TITLE_COLUMN_IDS,
        );
    }

    render() {
        return html`
    <slot>
        ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="table-container">
            <div id="businessUnitsMain">
                <div id="formCon">
                    <h1>Business Units</h1>
                    <div class="inputContainer">
                        ${this.isEnterpriseAdmin && !this.isReadOnlyUser ? html`
                        <jha-tooltip left text="Click to Add new Business Unit.">
                            <jha-button data-auto-id="addNewBusinessUnitButton" type="button" primary large
                                @click=${this.onAddBusinessUnit}>
                                <jha-icon-plus slot="icon-left"></jha-icon-plus>
                                Add Business Unit
                            </jha-button>
                        </jha-tooltip>
                        ` : html`<jha-button data-auto-id="addNewBusinessUnitButton" type="button" primary large disabled>
                            <jha-icon-plus slot="icon-left"></jha-icon-plus>
                            Add Business Unit
                        </jha-button>`}
                    </div>
                </div>
                <jha-card
                  >${renderGridWithTimezoneBanner(this.renderTable())}</jha-card
                >
            </div>
        </div>
    </slot>
    `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "business-units-main-view": BusinessUnitsMainView;
    }
}
